/**
 * Resolve shop logo URL from API fields (string, populated object, or legacy shape).
 */
export function getShopLogoUrl(image: unknown): string | undefined {
  if (!image) return undefined;
  if (typeof image === 'string') return image;
  if (typeof image === 'object' && image !== null && 'url' in image) {
    const url = (image as { url?: string }).url;
    return url || undefined;
  }
  return undefined;
}
